var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isRouterAlive)?_c('router-view',{staticClass:"page-content"}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }